import React, { useState } from 'react';
import styled from '@emotion/styled';

const TabList = styled.div`
  display: flex;
  background-color: #f8f9fa;
  width: 100%;
  margin: 0;
  padding-top: 0;
  box-shadow: none;
`;

const TabContent = styled.div`
  border-top: none;
  width: 100%;
`;
const TabButton = styled.button`
  ${({ visible }) => visible ? '' : 'display:none' };
  cursor: pointer;
  padding: 0.5rem 1rem;
  border: none;
  background-color: ${({ isActive, backColour }) => isActive ? backColour : 'transparent'};
  color: ${({ isActive }) => isActive ? 'white' : 'black'};
  border-bottom: ${({ isActive }) => isActive ? 'none' : '2px solid #dee2e6'};

  &:hover {
    background-color: ${({ hover }) => hover };
    color: white;
  }

  &:focus {
    outline: none;
  }
`;



export const TabController = ({ children, colours }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <TabList>
        {React.Children.map(children, (child, index) => (
          <TabButton
            key={index}
            isActive={index === activeTab}
            onClick={() => handleTabClick(index)}
            backColour={colours.menuContent}
            hover={colours.hoverColour}
            visible={child?.props?.visible}
          >
            {child?.props?.label}
          </TabButton>
        ))}
      </TabList>
      <TabContent>
        {React.Children.map(children, (child, index) =>
          index === activeTab ? child : undefined
        )}
      </TabContent>
    </div>
  );
};

export const DynamicTabController = ({ children, colours, activeTab, setActiveTab }) => {
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <TabList>
        {React.Children.map(children, (child, index) => (
          <TabButton
            key={index}
            isActive={index === activeTab}
            onClick={() => handleTabClick(index)}
            backColour={colours.menuContent}
            hover={colours.hoverColour}
            visible={child.props.visible}
          >
            {child.props.label}
          </TabButton>
        ))}
      </TabList>
      <TabContent>
        {React.Children.map(children, (child, index) =>
          index === activeTab ? child : undefined
        )}
      </TabContent>
    </div>
  );
};
